export default __webpack_public_path__ + "static/media/graph-icon.f06b8ebf.svg";